/** Level 5 (claude/level-5-source): Lessons 1–23 in book order plus the lettered lessons not in the book yet (extra.ts); Lesson 24 is the Check-Up (levels.ts, post). */
import type { Lesson } from "../types";
import * as A from "./lesson01to08";
import * as B from "./lesson09to17";
import * as C from "./lesson18to24";
import * as X from "./extra";

export const LEVEL5: Lesson[] = [
  A.L5_LESSON1, A.L5_LESSON2, A.L5_LESSON3, A.L5_LESSON4, X.L5_LESSON4A, A.L5_LESSON5, X.L5_LESSON5A, A.L5_LESSON6, A.L5_LESSON7, A.L5_LESSON8,
  B.L5_LESSON9, B.L5_LESSON10, B.L5_LESSON11, B.L5_LESSON12, B.L5_LESSON13, X.L5_LESSON13A, B.L5_LESSON14, B.L5_LESSON15, B.L5_LESSON16, X.L5_LESSON16A, B.L5_LESSON17, X.L5_LESSON17A,
  C.L5_LESSON18, C.L5_LESSON19, C.L5_LESSON20, C.L5_LESSON21, X.L5_LESSON21A, C.L5_LESSON22, C.L5_LESSON23,
];
export { L5_PRE, L5_POST } from "./lesson18to24";
